import { Routes, Route, useLocation } from 'react-router-dom';
import ScreenHeader from 'src/components/layout/ScreenHeader';
import { ResourcePlanner } from 'src/screens/ResourcePlanner';
import { SearchProjects } from 'src/screens/SearchProjects';
import { MoveHours } from 'src/screens/MoveHours';
import { designSevenPagePath } from 'src/designSevenPagePath';
import { SearchForTaskDialog } from 'src/screens/ResourcePlanner/screens/SearchForTaskDialog';
import { SearchForResourceDialog } from 'src/screens/ResourcePlanner/screens/SearchForResourceDialog';
import { SearchForProjectDialog } from 'src/screens/ResourcePlanner/screens/SearchForProjectDialog';
import PageRoute from '../PageRoute';

export const ProjectsRouter = () => {
  const location = useLocation();

  return (
    <Routes>
      <Route
        path={designSevenPagePath.projects.resourcePlanner}
        element={
          <>
            <ScreenHeader />
            <PageRoute
              pageTitle="ResourcePlanner"
              pageId="c210b1c5-f3df-44d8-b17c-43c10a504c0d"
              pageIdentifier="NewResourcePlanner"
            >
              <ResourcePlanner />
            </PageRoute>
          </>
        }
      >
        {location.pathname.startsWith('/projects/resource-planner/') && (
          <>
            <Route path="assign-resource/:id" element={<SearchForProjectDialog />} />
            <Route path="assign-resource/:id/:projectId/tasks" element={<SearchForTaskDialog />} />
            <Route path="assign-task/:id" element={<SearchForResourceDialog />} />
          </>
        )}
      </Route>

      <Route
        path={designSevenPagePath.projects.searchProjects}
        element={
          <>
            <ScreenHeader />
            <PageRoute
              pageTitle="SearchProjects"
              pageId="c3e04a88-0a00-487f-9e59-9d101a96462f"
              pageIdentifier="DesignSevenSearchProject"
              fallbackUrl="/projectManagement/Search/SearchProjects"
              key="SearchProjectsRouteKey"
            >
              <SearchProjects />
            </PageRoute>
          </>
        }
      />

      <Route
        path={designSevenPagePath.projects.moveHours}
        element={
          <>
            <ScreenHeader />
            <PageRoute
              pageTitle="MoveHours"
              pageId="7af9b8f1-dc98-4bc7-a1a4-9081451b0d1b"
              pageIdentifier="DesignSevenMoveHours"
              fallbackUrl="/projectManagement/Adjustment/RedistributionOfTime"
              key="MoveHoursRouteKey"
            >
              <MoveHours />
            </PageRoute>
          </>
        }
      />
    </Routes>
  );
};
